import {
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@material-ui/core';
import React, { FC } from 'react';
import LoyaltyReportDownload from '../../../../models/TenantReports/TransactionWiseReportDownload';
import TableBodyLoader from '../../../../shared/components/TableBodyLoader/TableBodyLoader';
import TableFooter from '../../../../shared/components/TableFooter/TableFooter';
import TableHeader from '../../../../shared/components/TableHeader/TableHeader';
import formatDate from '../../../../shared/utils/formatDate';
import Chip from '../../../../shared/components/Chip/Chip';
import { get, isNull } from 'lodash';
import zipDownloadIcon from '../../Assets/zip-download.png';
import { downloadReportFile } from '../../../../services/TenantReports/common';
import { toast } from 'react-toastify';
import moment from 'moment';
import LinearProgressWithLabel from '../../Shared/LinearProgressWithLabel';
import { GetApp } from '@material-ui/icons';
import { reportTypeLabel } from './Filter';

interface FraudReportDownloadTableProps {
  reports: LoyaltyReportDownload[];
  isLoading: boolean;
  page: number;
  offset: number;
  setPage: (page: number) => void;
  setOffset: (offset: number) => void;
}

const headings = [
  'S.No',
  'Date Triggered',
  'Report Type',
  'Start Date',
  'End Date',
  'Progress',
  'Status',
  'Download'
];

const FraudReportDownloadTable: FC<FraudReportDownloadTableProps> = props => {
  const { reports, isLoading, page, offset, setPage, setOffset } = props;

  const getFileNameForDownload = (report: LoyaltyReportDownload) => {
    const fileType = isCSVFile(report) ? 'csv' : 'zip';
    return `Member_BillWise_Report_${moment().valueOf()}.${fileType}`;
  };
  const getDownloadReportUrl = async (
    report: LoyaltyReportDownload
  ): Promise<any> => {
    const url = report.errorFileLocation;
    try {
      if (isNull(url)) {
        return;
      }
      const fileName = getFileNameForDownload(report);
      await downloadReportFile(url, fileName);
    } catch (e) {
      toast.error('Something went wrong!!!');
    }
  };
  const isCSVFile = (report: LoyaltyReportDownload) => {
    const fileType = get(report, 'data.fileType', 'csv');
    return fileType === 'csv';
  };
  const getReportType = (type: string) => {
    if (type === 'enroll' || type === 'transaction') {
      return reportTypeLabel[type];
    }
    if (type) {
      return type;
    }
    return '';
  };
  return (
    <TableContainer component={Paper} elevation={0}>
      <Table>
        <TableHeader headings={headings} align="center" />
        {isLoading ? (
          <TableBodyLoader colSpan={headings.length} rowsPerPage={offset} />
        ) : (
          <TableBody>
            {reports.map((report, index) => (
              <TableRow key={report.id}>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center">
                  {' '}
                  {formatDate(report.createdAt)}{' '}
                </TableCell>
                <TableCell align="center">
                  {' '}
                  {getReportType(report?.data?.type || '')}{' '}
                </TableCell>
                <TableCell align="center">
                  {' '}
                  {formatDate(report?.data?.date?.startDate)}{' '}
                </TableCell>
                <TableCell align="center">
                  {formatDate(report?.data?.date?.endDate)}
                </TableCell>
                <TableCell align="center">
                  <LinearProgressWithLabel
                    total={report.total}
                    currentValue={report.processedRecords}
                  />
                </TableCell>
                <TableCell align="center">
                  <Chip
                    label={report.status}
                    color={
                      report.status === 'COMPLETED'
                        ? 'success'
                        : report.status === 'FAILED'
                        ? 'error'
                        : 'primary-light'
                    }
                  />
                </TableCell>
                <TableCell align="center">
                  {isCSVFile(report) ? (
                    <IconButton
                      disabled={report.status !== 'COMPLETED'}
                      component="a"
                      onClick={() => getDownloadReportUrl(report)}
                      download
                    >
                      <GetApp />
                    </IconButton>
                  ) : (
                    <Button
                      onClick={() => getDownloadReportUrl(report)}
                      disabled={report.status !== 'COMPLETED'}
                    >
                      <img
                        src={zipDownloadIcon}
                        alt={'download'}
                        style={{
                          width: '3rem',
                          opacity: `${
                            report.status !== 'COMPLETED' ? '50%' : '100%'
                          }`
                        }}
                      />
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
        <TableFooter
          colSpan={headings.length}
          count={-1}
          page={page}
          rowsPerPage={offset}
          onPageChange={setPage}
          onRowPerPageChange={setOffset}
        />
      </Table>
    </TableContainer>
  );
};

export default FraudReportDownloadTable;
